// extracted by css-extract-rspack-plugin
export default {"wrap":"wrap-eaRYtY","table":"table-IEj5Bj","primary":"primary-bS8Lrc","end":"end-Si7k6N","actions":"actions-ObbhsM"};